export function headingSpan() {
    const headings = document.querySelectorAll(".is-style-heading-1")
	if (headings) {
       headings.forEach(_h => {
		  const arr = _h.textContent.split("");
		  const spans =[];
		  arr.forEach(_c => {
			if (_c == " ") {
  				spans.push("</span><span class='page-title-letter page-title-space'>&nbsp;</span><span class='page-title-word'>");
		  	} else {
		  		spans.push("<span class='page-title-letter'>" + _c + "</span>");
		  	}
		  })
		  _h.innerHTML = "<span class='page-title-letters'><span class='page-title-word'>" + spans.join("") + "</span></span>";
       })
	}
}